import { Color } from 'three/src/math/Color';
import { ShaderLib } from '../shaders/ShaderLib';
import THREE from '../utils/threeClassesAdapter';

export class FlagMeshMatcapMaterial extends THREE.ShaderMaterial {
    constructor(parameters) {
        const {
            color,
            matcap,
            map
        } = parameters;

        // color0, color1 - colors of any format appropriate for THREE.Color
        // ratio0, ratio1 - relative color positions, the order from the less value to the higher one
        // if ratio1 or ratio2 is less then zero then the corresponding color is ignored
        // rotate - linear gradient orientation, 0 is from the bottom to the top, corresponds to css linear-gradient, by degrees

        const { uniforms, vertexShader, fragmentShader } = ShaderLib.flagMatcap;

        super({
            uniforms: THREE.UniformsUtils.clone(uniforms),
            defines: {
                ALPHA_TEST: false,
                MATCAP: ''
            },
            side: THREE.DoubleSide,
            vertexShader,
            fragmentShader
        });

        this.transparent = false;
        this.color = color ? new Color(color) : new Color(0xffffff); // diffuse
        this.matcap = null;
        this.map = null;

        if (matcap) this.uniforms.matcap.value = matcap;
        if (map) this.uniforms.map.value = map;
        if (this.color) this.uniforms.diffuse.value = this.color;

        this.needsUpdate = true;
        this.initiated = true;
    }

    set matcap(value) {
        if (this.initiated) this.uniforms.matcap.value = value;
    }

    get matcap() {
        if (!this.initiated) return null;

        return this.uniforms.matcap.value;
    }

    set map(value) {
        if (this.initiated) this.uniforms.map.value = value;
    }

    get map() {
        if (!this.initiated) return null;

        return this.uniforms.map.value;
    }

    set time(value) {
        this.uniforms.time.value = value;
    }

    get time() {
        return this.uniforms.time.value;
    }
}
